<template>

	<table class="cart-items-table">
		<!-- Table header -->
		<thead class="cart-items-table__head">
			<tr>
				<th>Actions</th>

				<th>Product</th>
				<th><span class="visually-hidden">Product Name</span></th>

				<th>Price</th>
				<th>Quantity</th>
				<th>Total</th>
			</tr>
		</thead>

		<!-- Product row -->
		<tbody v-for="(item, index) in items" :key="index">

			<!-- Desktop row -->
			<tr class="cart-items-table__row d-none d-md-table-row">
				<!-- Remove button -->
				<td class="text-center">
					<i class="far fa-times-circle remove-icon" @click="$emit('remove-item', item)"></i>
				</td>

				<!-- Image -->
				<td class="image-container">
					<img class="product-image" :src="item | getItemImage" @click="handleProductClick(item)" :alt="item.offer_snapshot.title"> 
				</td>

				<!-- Product name -->
				<td>
					{{ item.offer_snapshot.title }}
				</td>

				<!-- Price -->
				<td>
					<span>{{ item.offer.price_local.amount.formatted }}</span> 
				</td>

				<!-- Quantity -->
				<td>
						<!-- <input class="form-control" oninput="this.value=this.value.replace(/[^0-9]/g,'');"  onkeypress="return (event.charCode == 8 || event.charCode == 0) ? null : event.charCode >= 48 && event.charCode <= 57" type="number" step="1" min="0" max="" v-model.number="item.quantity" inputmode="numeric"> -->
						<b-form-select v-model="item.quantity" :options="quantityOptions" @input="$emit('update-quantity', item)" />
				</td>

				<!-- Total (price x quantity) -->
				<td style="min-width:100px;">
					<span>{{ item.amount_local.formatted }}</span> 
				</td>
			</tr>
			<!-- End desktop row -->

			<!-- Mobile row -->
			<tr class="cart-items-table__row d-md-none">
				<b-container>
					<b-row>

						<!-- Image -->
						<b-col cols="4" class="p-1">
							<i class="far fa-times-circle remove-icon" @click="$emit('remove-item', item)"></i>
							<div class="image-container">
								<img class="product-image" :src="item | getItemImage" :alt="item.offer_snapshot.title"> 
							</div>
						</b-col>
						
						<b-col cols="8" class="p-0 pr-2">
							<!-- Product name -->
							<td>{{ item.offer_snapshot.title }}</td>

							<!-- Price -->
							<td class="d-inline-block">
								<h6>Price:</h6>
								<span>{{ item.offer.price_local.amount.formatted }}</span> 
							</td>

							<!-- Total (price x quantity) -->
							<td class="d-inline-block">
								<h6>Total:</h6>
								<span>{{ item.amount_local.formatted }}</span> 
							</td>

							<!-- Quantity select -->
							<td>
								<!-- <input class="form-control" oninput="this.value=this.value.replace(/[^0-9]/g,'');"  onkeypress="return (event.charCode == 8 || event.charCode == 0) ? null : event.charCode >= 48 && event.charCode <= 57" type="number" step="1" min="0" max="" v-model.number="item.quantity" inputmode="numeric"> -->
								<b-form-select v-model.number="item.quantity" :options="quantityOptions" />
							</td>
						</b-col>

					</b-row>
				</b-container>
			</tr>
			<!-- End mobile row -->
				
		</tbody>
	</table>

</template>

<script>

	export default {
		props: {
			items: Array
		},

		data() {
			return {
				quantityOptions: []
			}
		},

		filters: {
			getItemImage(item) {
				return item.offer.media[0]?.url;
			}
		},

		mounted() {
			for (let i = 1; i <= 10; ++i) {
				this.quantityOptions.push({ value: i, text: i });
			}
		},

		methods: {
			handleProductClick(item) {
				item.offer.route && item.offer.route.slug ? window.location = `/${item.offer.route.slug}` : '#';
			}
		}
	}

</script>

<style lang="scss" scoped>

	.cart-items-table {
		background-color: white;
		width: 100%;
		border: 1px solid #dee2e6;
		border-radius: 8px;
		border-collapse: unset;
	}

	.cart-items-table__row td {
		border-top: 1px solid #dee2e6;
		padding: 0.75rem;
	}

	.cart-items-table__head th {
		padding: 0.75rem;
	}

	.image-container {
		width: 120px;
		height: 120px;
	}

	.product-image {
		max-width: 100%;
		max-height: 100%;
	}

	.product-image:hover {
		cursor: pointer;
	}

	.remove-icon {
		font-size: 18px;
		color: lightgray;
		cursor: pointer;
		transition: all .3s ease;
	}

	.remove-icon:hover {
		color: #cf0614;
	}

	.visually-hidden {
		display: none;
	}

	@media (max-width: 767px) {
		.cart-items-table {
			background-color: transparent;
			border: none;
		}

		.cart-items-table__head th {
			display: none;
		}

		.cart-items-table__row, .cart-items-table__row td {
			display: block;
			text-align: center;
			margin: auto;
		}

		.cart-items-table__row td {
			border: none;
		}

		.cart-items-table__row {
			background-color: white;
			border: 1px solid #dee2e6;
			border-radius: 10px;
			margin-bottom: 20px;
		}

		.image-container {
			display: flex;
			align-items: center;
			width: 100%;
			height: 100%;
		}

		.remove-icon {
			position: absolute;
			top: 6px;
			left: 6px;
		}
	}

</style>
